import { useState } from 'react';
import type { RentComp } from '../../types/calculations';

interface RentCompsTableProps {
  comps: RentComp[];
  title: string;
  renovationStatus: 'renovated' | 'unrenovated';
}

export function RentCompsTable({ comps, title, renovationStatus }: RentCompsTableProps) {
  const [expanded, setExpanded] = useState(false);

  if (!comps || !comps.length) return null;

  const StatusBadge = renovationStatus === 'renovated'
    ? <span className="text-green-600 text-sm font-medium">Reno</span>
    : <span className="text-gray-500 text-sm font-medium">Orig</span>;

  return (
    <div className="mt-2">
      <button
        onClick={() => setExpanded(!expanded)}
        className="text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1"
      >
        <span className="transition-transform duration-200" style={{ transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)' }}>
          &#9654;
        </span>
        {title} ({comps.length})
      </button>

      {expanded && (
        <table className="mt-2 w-full text-sm border border-gray-200 rounded-lg overflow-hidden">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-2 py-1.5 text-left text-sm font-medium text-gray-500">#</th>
              <th className="px-2 py-1.5 text-left text-sm font-medium text-gray-500">Address</th>
              <th className="px-2 py-1.5 text-right text-sm font-medium text-gray-500">Rent</th>
              <th className="px-2 py-1.5 text-center text-sm font-medium text-gray-500">Beds</th>
              <th className="px-2 py-1.5 text-right text-sm font-medium text-gray-500">SqFt</th>
              <th className="px-2 py-1.5 text-right text-sm font-medium text-gray-500">Dist</th>
              <th className="px-2 py-1.5 text-center text-sm font-medium text-gray-500">Status</th>
            </tr>
          </thead>
          <tbody>
            {comps.map((comp, i) => (
              <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="px-2 py-1.5 text-gray-600">{i + 1}</td>
                <td className="px-2 py-1.5 truncate max-w-[200px] text-gray-700" title={comp.address}>
                  {comp.address}
                </td>
                <td className="px-2 py-1.5 text-right font-mono text-gray-700">
                  ${comp.rent.toLocaleString()}
                </td>
                <td className="px-2 py-1.5 text-center text-gray-600">
                  {comp.bedrooms}BR
                </td>
                <td className="px-2 py-1.5 text-right text-gray-600">
                  {comp.sqft ? comp.sqft.toLocaleString() : '-'}
                </td>
                <td className="px-2 py-1.5 text-right text-gray-600">
                  {comp.distance_miles.toFixed(1)}mi
                </td>
                <td className="px-2 py-1.5 text-center">
                  {StatusBadge}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
